var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqualplayLogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 641,
    height: 641,
    viewBox: "0 0 641 641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Logo_12);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #27aa69;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n        stroke: #27aa69;\r\n        stroke-width: 40px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 641
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_12",
    "data-name": "Logo \\u2013 12",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-2",
    cx: 320,
    cy: 320,
    r: 320
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_21",
    "data-name": "Polygon 21",
    className: "cls-3",
    d: "M209.531,18.648a15,15,0,0,1,24.938,0L428.395,308.662A15,15,0,0,1,415.925,332H28.075a15,15,0,0,1-12.469-23.338Z",
    transform: "translate(535 98) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    className: "cls-4",
    y1: 1.113,
    x2: 176.01,
    transform: "translate(135.207 278.677)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "cls-4",
    y1: 1.113,
    x2: 176.01,
    transform: "translate(135.207 361.076)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualplayLogoGreen);
export default __webpack_public_path__ + "static/media/equalplay_logo_green.361d7b58e4f84c550b1023fcc053a780.svg";
export { ForwardRef as ReactComponent };